import React, { useRef, useEffect, useState } from "react";

import useHttp from "../../../hooks/use-http";

import moment from "moment";

import Pagination from "../../../components/Pagination";
import { toast } from "react-toastify";
import { useAuth } from "../../../store/auth";

const AutoApprovalForm = (props) => {
  const frmRef = useRef({});
  const [employeeId, setEmployeeId] = useState(0);
  const [employeeData, setEmployeeData] = useState([]);
  const [moduleId, setModuleId] = useState(0);
  const [moduleData, setModuleData] = useState([]);

  const [data, setData] = useState([]);

  const { sendRequest: getEmp } = useHttp();
  const getAllEmp = () => {
    getEmp(
      {
        url: `/api/employee/?orgId=${localStorage.getItem(
          "orgId"
        )}`,
      },
      (data) => {
        var emplist = data.output; //data.output.filter((item) => item.useCase == "Procurement");

        setEmployeeData(emplist);
      }
    );
  };

  useEffect(() => {
    getAllEmp();
  }, []);

  const { sendRequest: getModuleMaster } = useHttp();
  const getModule = () => {
    getModuleMaster(
      {
        url: `/api/moduleMaster/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        //console.log(data);
        setModuleData(data);
      }
    );
  };

  useEffect(() => {
    getAllEmp();
    getModule();
  }, []);

  const { sendRequest: getSubServices } = useHttp();

  const getSubServiceData = () => {
    getSubServices(
      {
        url: `/api/getserviceforautoapproval/?employeeId=${employeeId}&moduleId=${moduleId}&orgId=${localStorage.getItem(
          "orgId"
        )}`,
      },
      (data) => {
        //console.log(data.output);
        setData(data.output);
      }
    );
  };

  useEffect(() => {
    getSubServiceData();
  }, [moduleId]);

  const handleCheckboxChange = (serviceId) => {
    const newData = [...data];
    const itemIndex = newData.findIndex((item) => item.serviceId === serviceId);
  
    if (itemIndex !== -1) {
      newData[itemIndex].autoApproval = newData[itemIndex].autoApproval === 0 ? 1 : 0;
      setData(newData);
      console.log(newData);
    }
  };

  const { sendRequest: postAutoApproval } = useHttp();

  const submitHandler = (e) => {
    e.preventDefault();

    const updatedData = data.map((item) => ({
        ...item,
        employeeId: employeeId,
        createdBy: parseInt(localStorage.getItem("id")),
        orgId: localStorage.getItem("orgId"),
        status: 1,
      }));

      console.log(updatedData);

    postAutoApproval(
        {
          url: "/api/autoapprovalProcess/",
          method:  "POST",
          body: updatedData,
        },
        (res) => {
          toast.success("Auto Approval Save Successfully");
          props.addForm(false);
   
        }
      );
  };

  const [itemsPerPage] = useState(15);
  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data && data.slice(indexOfFirstItem, indexOfLastItem);
  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <>
      <div className="content-wrapper">
        <form onSubmit={submitHandler}>
          <section className="content">
            <div className="container-fluid">
              <div className="row mx-2">
                <div className="col-md-9">
                  <br />
                  <label className="">Auto Approval</label>
                </div>
                <div className="col-md-3">
                  <br />
                  <div className="text-right">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="remove"
                      onClick={() => props.addForm(false)}
                    >
                      <i className="fas fa-times" />
                    </button>
                  </div>
                </div>{" "}
              </div>

              <div className="row mt-3 mx-3">
                <div className="col-md-3">
                  <label htmlFor={"executive_officer"}>
                    {"Assign Supervisor"}
                  </label>
                  <select
                    id="emp_id"
                    className="form-control"
                    ref={(el) => (frmRef.current["emp_id"] = el)}
                    value={employeeId}
                    required
                    onChange={(e) => {
                      setEmployeeId(e.target.value);
                    }}
                  >
                    <option value="">Select</option>
                    {employeeData &&
                      employeeData.map((x) => (
                        <option key={x.userId} value={x.empId}>
                          {x.employeeName}
                        </option>
                      ))}
                  </select>
                </div>
                <div className="col-md-3">
                  <label htmlFor={"module_id"}>{"Module Name"}</label>

                  <select
                    id="moduleId"
                    className="form-control"
                    ref={(el) => (frmRef.current["moduleId"] = el)}
                    required
                    value={moduleId}
                    onChange={(e) => {
                      setModuleId(e.target.value);
                    }}
                  >
                    <option value="">Select</option>
                    {moduleData &&
                      moduleData.map((x) => (
                        <option key={x.moduleId} value={x.moduleId}>
                          {x.moduleName}
                        </option>
                      ))}
                  </select>
                </div>
              </div>
            </div>

            <hr />
          </section>

          <section className="content">
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-12">
                  <div className="card">
                    <div className="card-body" style={{ padding: "1.4rem" }}>
                      <table className="table table-bordered text-center table-sm">
                        <thead>
                          <tr className="table-header">
                            <th>Sub Service Name </th>
                            <th>Service Name</th>
                            <th>Check</th>
                          </tr>
                        </thead>

                        {currentItems &&
                          currentItems.map((itm, i) => {
                            return (
                              <tr key={i} className="tablerowview">
                                <td> {itm.serviceSubName} </td>

                                <td> {itm.serviceName} </td>

                                <td>
                                  <input
                                    type="checkbox"
                                    className="form-control-check"
                                    checked={itm.autoApproval === 1}
                                    onChange={() =>
                                      handleCheckboxChange(itm.serviceId)
                                    }
                                  />
                                </td>
                              </tr>
                            );
                          })}
                      </table>
                    </div>

                    <div className="card-footer clearfix">
                      <Pagination
                        totalItems={data.length}
                        itemsPerPage={itemsPerPage}
                        onPageChange={paginate}
                        currentPage={currentPage}
                        setCurrentPage={setCurrentPage}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <div className="">
            <div className="text-center">
              <button type="submit" className="btn btn-primary mb-4">
                Submit
              </button>
            </div>
          </div>
        </form>
      </div>
    </>
  );
};

export default AutoApprovalForm;
